import Flickity from 'flickity';
import 'flickity-imagesloaded';

let sliderArray = [];
initMobileSlider();

function initMobileSlider() {
  const collectionElements = document.querySelectorAll(
    '.list-collection__products'
  );
  if (collectionElements.length > 0) {
    if (sliderArray.length === 0) {
      for (let i = 0; i < collectionElements.length; i++) {
        const index = collectionElements[i].getAttribute('data-index');
        const slides = collectionElements[i].querySelectorAll('.product-card');

        if (slides.length > 1) {
          var collectionSlider = new Flickity('[data-index="' + index + '"]', {
            freeScroll: false,
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            setGallerySize: true,
            cellAlign: 'left',
            watchCSS: true,
            wrapAround: false,
          });

          sliderArray.push(collectionSlider);
        }
      }
    }
  }
}
